import type { Finding } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapSingle } from '../normalize'

export type FindingPayload = {
  namespace: string
  farmId: string
  createdBy: string
  metricEventId: string | null
  formDefinitionVersion: string
  type: number
  metricEventsFieldsObserved: string[]
  comment: string
  dataCollectionStatementId: string
  userRole: string
}

export const saveFinding = async ({ payload }: { payload: FindingPayload }): Promise<Finding> => {
  const response = await apiClient.post(`${endpoints.findings}/`, payload)
  return unwrapSingle<Finding>(response)
}

export default saveFinding
